var _defs, _rect, _path, _path2, _rect2, _circle, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaijaPropertyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 52,
    viewBox: "0 0 270 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "roof",
    x1: 8,
    y1: 3,
    x2: 44,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AB673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F7A4E"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 50,
    height: 50,
    rx: 14,
    fill: "#EAF8F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 24L26 9L44 24",
    stroke: "url(#roof)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 23V39C12 40.1046 12.8954 41 14 41H38C39.1046 41 40 40.1046 40 39V23",
    stroke: "#0F7A4E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 30,
    width: 6,
    height: 11,
    rx: 1.5,
    fill: "#0F7A4E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 13,
    r: 5,
    fill: "#F2B84B"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 25,
    fill: "#0F7A4E",
    fontSize: 18,
    fontFamily: "Inter, Segoe UI, Arial, sans-serif",
    fontWeight: 800,
    letterSpacing: 0.4
  }, "NaijaNest")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 41,
    fill: "#4D6B59",
    fontSize: 12,
    fontFamily: "Inter, Segoe UI, Arial, sans-serif",
    fontWeight: 600,
    letterSpacing: 0.35
  }, "Search and list with clarity.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaijaPropertyLogo);
export default __webpack_public_path__ + "static/media/naija-property-logo.9a481cc1d70cee83289e3256fd35f50e.svg";
export { ForwardRef as ReactComponent };